(() => {
  const storageKey = 'retroparty:wishlist';

  function readCount() {
    try {
      const value = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(value) ? value.length : 0;
    } catch {
      return 0;
    }
  }

  function renderCount() {
    const count = readCount();
    document.querySelectorAll('[data-rp-wishlist-count]').forEach((badge) => {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    });
    document.querySelectorAll('[data-rp-wishlist-link]').forEach((link) => {
      link.classList.toggle('has-items', count > 0);
    });
  }

  window.addEventListener('storage', (event) => {
    if (event.key === storageKey) renderCount();
  });
  document.addEventListener('retroparty:wishlist-updated', renderCount);
  document.addEventListener('shopify:section:load', renderCount);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderCount, { once: true });
  } else {
    renderCount();
  }
})();
